export default __webpack_public_path__ + "static/794-75237f50a654cdf49bde4bb758d6008d.gif";